import { KIND_DOT, KIND_LABEL, type Kind } from '../lib/browse'

/**
 * The third heading level a list clustered by kind sits under — quieter than
 * `.rowhead`'s day and `.tsec__head`'s section, because it is neither: a
 * chip's own dot and word, over a group of rows rather than a single one.
 * WP 5.0's reason for existing — Doug on the shipped lists: "I don't even
 * know if they're movies or not" — is that a colour alone never said what
 * kind of evening a row was; this is the same word (`rowMeta.ts`'s
 * `kindWord`) at the scale of a cluster instead of one row.
 *
 * No consumer yet: 5.2 and 5.4 are what actually put a clustered Browse or
 * Today list under one of these.
 */
export function KindHeading({ kind, count }: { kind: Exclude<Kind, 'all'>; count: number }) {
  return (
    <div className="kindhead">
      <i className="kindhead__dot" style={{ background: KIND_DOT[kind] }} aria-hidden="true" />
      <span>{KIND_LABEL[kind]}</span>
      <span className="g">{count}</span>
    </div>
  )
}
